import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledAllowTitleTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  line-height: 28px;
`;

export const StyledAllowedIcon = styled(AddCircleOutlineIcon)`
  color: ${({ theme }) => theme.palette.success.main};
  margin-top: ${({ theme }) => theme.spacing(0.35)};
  margin-right: ${({ theme }) => theme.spacing(1.5)};
`;

export const StyledAllowedFiltersGrid = styled(Grid)`
  position: relative;
  width: fit-content;

  &:hover {
    .removeIconWrapper {
      visibility: visible;
    }
  }
`;

export const StyledRemoveIconWrapperDiv = styled('div')`
  background: ${({ theme }) => `linear-gradient(270deg, ${theme.palette.background.antiflashWhite} 49.09%, transparent 100%)`};
  border-radius: 0px 28px 28px 0px;
  position: absolute;
  right: 7px;
  text-align: right;
  top: 0;
  visibility: hidden;
  width: 50px;
`;

export const StyledRemoveIconButton = styled(IconButton)`
  padding: ${({ theme }) => theme.spacing(0.5)};
`;

export const StyledFilterTitleTypography = styled(Typography)`
  line-height: 28px;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;
